import {
    IProps,
} from './types';

import React, {
    FC,
} from 'react';

const ClockImage: FC<IProps> = (props) => {
    return (
        <svg
            className={props.className}
            width={'11'}
            height={'11'}
            viewBox={'0 0 11 11'}
            fill={'none'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path d={'M5.22521 10.4342C7.81249 10.4342 9.9099 8.21939 9.9099 5.48734C9.9099 2.75529 7.81249 0.540527 5.22521 0.540527C2.63793 0.540527 0.540527 2.75529 0.540527 5.48734C0.540527 8.21939 2.63793 10.4342 5.22521 10.4342Z'} stroke={'currentColor'} strokeWidth={'1.08108'}/>
            <path d={'M5.22559 2.44336V5.48755L7.74811 7.00965'} stroke={'currentColor'} strokeWidth={'1.08108'} strokeLinecap={'round'} strokeLinejoin={'round'}/>
        </svg>
    );
};

export default ClockImage;
